import { adminRequests } from 'api/request';
import urls from 'configs/urls';

export const getDoctorProfiles = ({ data }) =>
  adminRequests.get(null, false, urls.doctorsUrls.getDoctorProfiles, data);

export const getDoctorUserInfo = ({ userKey }) =>
  adminRequests.get(null, false, `${urls.doctorsUrls.getDoctorUserInfo}/${userKey}`);

export const updateDoctorLicenceStatus = ({ data, profileKey }) =>
  adminRequests.patch(
    null,
    false,
    `${urls.doctorsUrls.updateDoctorLicenceStatus(profileKey)}`,
    data,
  );

export const getDoctorBadges = ({ profileKey }) =>
  adminRequests.get(null, false, `${urls.doctorsUrls.getDoctorBadges(profileKey)}`);

export const assignDoctorBadges = ({ data, profileKey }) =>
  adminRequests.post(
    null,
    false,
    `${urls.doctorsUrls.assignOrRevokeDoctorBadges(profileKey)}`,
    data,
  );

export const revokeDoctorBadges = ({ data, profileKey }) =>
  adminRequests.delete(
    null,
    false,
    `${urls.doctorsUrls.assignOrRevokeDoctorBadges(profileKey)}`,
    data,
  );
